export interface IVehiclesWithoutDevice {
    id: string;
    licensePlate: string;
    deviceType: string;
    deviceCode: string;
}

export interface IDriversWithoutDevice {
    id: string;
    phoneNumber: string;
}
